<template>
  <div class="hello" style="height: 100vh;" v-loading="loading" element-loading-background="rgba(0, 0, 0, 0.8)">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="
                  position: fixed;
                  z-index: 111;
                  background: #fff;
                  width: calc(100% - 175px);
                ">
        <div class="edit">
          <div class="fl" style="justify-content: space-between; margin-left: 6px">
            <span style="width: 63px; background-color: #589ff9"    @click="openChildDialog(1)">
              <img src="../../../images/increase.png" style="width: 15px; height: 15px" alt=""
              />
            </span>
            <span style="width: 69px; display: block" @click="cleanUpEvt">ALL</span>
          </div>
          <el-tooltip class="item" effect="dark" content="转移时间" placement="bottom">
            <el-date-picker v-model="value0" style="width: 137px;margin-left: 6px;" type="daterange"
              :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator="" start-placeholder="转移时间"
              align="right" :class="{ 'your-css-class_box': !isValue3Empty_1 }" value-format="timestamp"
              @change="getList">
            </el-date-picker>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="转出账户" placement="bottom">
            <el-select v-model="account_out_name" filterable placeholder="转出账户" @change="account_outChange"
              style="margin-left: 6px;" clearable :class="{ 'vip': account_out_name && account_out_name !== '转出账户' }">
              <el-option v-for="(value, key) in account_one" :key="key" :label="value.name"
                :value="value.bank_account_id">
              </el-option>
            </el-select>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="转入账户" placement="bottom">
            <el-select v-model="account_in_name" filterable placeholder="转入账户" @change="account_inChange"
              style="margin-left: 6px;" clearable :class="{ 'vip': account_in_name && account_in_name !== '转入账户' }">
              <el-option v-for="(value, key) in account_one" :key="key" :label="value.name"
                :value="value.bank_account_id">
              </el-option>
            </el-select>
          </el-tooltip>


          <el-tooltip class="item" effect="dark" content="转入币种" placement="bottom">
            <el-select v-model="currency_in_name" filterable placeholder="转入币种" @change="currency_inChange"
              style="margin-left: 6px;" clearable :class="{ 'vip': currency_in_name && currency_in_name !== '转入币种' }">
              <el-option v-for="(value, key) in currency_one" :key="key" :label="value.name" :value="value.currency_id">
              </el-option>
            </el-select>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="转出币种" placement="bottom">
            <el-select v-model="currency_out_name" filterable placeholder="转出币种" @change="currency_outChange"
              style="margin-left: 6px;" clearable :class="{ 'vip': currency_out_name && currency_out_name !== '转出币种' }">
              <el-option v-for="(value, key) in currency_one" :key="key" :label="value.name" :value="value.currency_id">
              </el-option>
            </el-select>
          </el-tooltip>

          <span style="margin-left: 5px" @click="excelEvt">EXCEL</span>
        </div>
          <span class="span">{{ total }}</span>

        <div class="pagination_box">
          <el-input v-model="paginationInput" style="width: 50px" size="mini" placeholder="To"></el-input>
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
            :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5">
          </el-pagination>
        </div>
        <div class="" style="width: 100%">
          <el-tabs>
            <el-table :data="tableData" border ref="sortTable" style="width: 100%" @cell-mouse-enter="huaguo"
              @sort-change="sortChangeEvt" @cell-click="idEvt" v-sort-orders="['descending', 'ascending', '']">
              <el-table-column fixed prop="transfer_time" label="转移时间" width="120" sortable="custom">
              </el-table-column>
              <el-table-column prop="account_out_name" label="转出账户" width="240" sortable="custom"  class-name="project_one">
              </el-table-column>
              <el-table-column prop="amount_out" label="转出金额" width="120" sortable="custom"  class-name="project_one">
              </el-table-column>
              <el-table-column prop="currency_out_name" label="转出币种" width="120" sortable="custom"  class-name="project_one">
              </el-table-column>
              <el-table-column prop="account_in_name" label="转入账户" width="240" sortable="custom"  class-name="project_two">
              </el-table-column>
              <el-table-column prop="amount_in" label="转入金额" width="120" sortable="custom" class-name="project_two">
              </el-table-column>
              <el-table-column prop="currency_in_name" label="转入币种" width="120" sortable="custom" class-name="project_two">
              </el-table-column>
              <el-table-column prop="exchange_out" label="转移汇率" width="100" sortable="custom">
              </el-table-column>
              <el-table-column prop="remark" label="备注" width="500" sortable="custom">
              </el-table-column>
              <el-table-column label="操作" >
                <template slot-scope="props">
                  <el-button type="text" size="small" @click="openChildDialog(2)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tabs>
        </div>
      </div>
    </el-main>

    <el-dialog :visible.sync="dialogVisible" :show-close="false" custom-class="maxss" width="835px" :top="dialogTop"
      style="overflow: hidden;">
      <div class="whole" ref="whole">
        <div style="width: 815px;margin-left: 10px; position: fixed;">
          <div class="cloneEvt">
            <span @click="saveEvt"  style="cursor: pointer;">Save</span>
            <span  @click="open"   style="cursor: pointer;">Del</span>
          </div>
          <div>
            <div class="Completion_status">
              <div  style="width: 800px;height: 300px; display: flex;justify-content: space-between;">
                    <div  style=" width: 300px; margin-left:10px">
                           <el-input v-model="id" placeholder="ID" readonly  style="text-align: center;margin-top: 20px;"></el-input>
                      <div style="margin-top: 40px;">
                        <span style="display: flex;text-align: left;margin-left: 15px;">转出金额</span>
                          <el-tooltip class="item" effect="dark" content="转出金额" placement="bottom">
                            <el-input v-model="amount_out"  @input="validateInput()"  placeholder="请填写(必填)"  ></el-input>
                          </el-tooltip>
                      </div>

                     <div style="margin-top: 20px;">
                        <span style="display: flex;text-align: left;margin-left: 15px;">转出货币</span>
                          <el-tooltip class="item" effect="dark" content="转出币种" placement="bottom">
                            <el-select v-model="currency_out_name_one" filterable placeholder="转出币种" @change="currency_out_oneChange"
                            clearable>
                              <el-option v-for="(value, key) in currency_one" :key="key" :label="value.name"
                                :value="value.currency_id">
                              </el-option>
                            </el-select>
                          </el-tooltip>
                     </div>
                      <div style="margin-top: 20px;">
                          <span style="display: flex;text-align: left;margin-left: 15px;">转出账户</span>
                             <el-tooltip class="item" effect="dark" content="转出账户" placement="bottom">
                                <el-select v-model="account_out_name_one" filterable placeholder="转出账户" @change="account_out_oneChange"
                                  clearable>
                                  <el-option v-for="(value, key) in account_one" :key="key" :label="value.name"
                                    :value="value.bank_account_id">
                                  </el-option>
                                </el-select>
                              </el-tooltip>
                       </div>
                    </div>
                      <div style="width: 300px; ">
                            <div style="margin-top: 105px;">
                                  <span style="display: flex;margin-left:70px;">转换汇率</span>
                                  <el-tooltip class="item" effect="dark" content="转移汇率" placement="bottom">
                                    <input type="text"  readonly  v-model="exchange_out"   placeholder="只读" style="width: 158px;height:210px;text-align: center;
                                    border-radius: 5px;border:1px solid #d1d1d1; font-size: 20px;color: #797676;margin-top: 5px;" >
                                  </el-tooltip>
                            </div>
                      </div>
                       <div style="width: 300px;">
                                 <el-date-picker v-model="value1" style="width:280px;margin-top: 18px;" type="date"
                                        :picker-options="pickerOptions" size="mini" format="yyyy-MM-dd" range-separator=""
                                        placeholder="转出时间" align="right" value-format="timestamp">
                                  </el-date-picker>

                                  <div style="margin-top: 40px;">
                                          <span style="display: flex;text-align: left;margin-left: 15px;">转入金额</span>
                                              <el-tooltip class="item" effect="dark" content="转入金额" placement="bottom">
                                                <el-input v-model="amount_in"   @input="validateInput()"  placeholder="请填写(必填)"></el-input>
                                              </el-tooltip>
                                  </div>

                                <div style="margin-top:20px;">
                                        <span style="display: flex;text-align: left;margin-left: 15px;">转入货币</span>
                                        <el-tooltip class="item" effect="dark" content="转入货币" placement="bottom">
                                            <el-select v-model="currency_in_name_one" filterable placeholder="转入货币" @change="currency_in_oneChange"
                                              clearable>
                                              <el-option v-for="(value, key) in currency_one" :key="key" :label="value.name"
                                                :value="value.currency_id">
                                              </el-option>
                                            </el-select>
                                          </el-tooltip>
                                  </div>

                                    <div style="margin-top:20px;">
                                        <span style="display: flex;text-align: left;margin-left: 15px;">转入账户</span>
                                        <el-tooltip class="item" effect="dark" content="转入账户" placement="bottom">
                                            <el-select v-model="account_in_id" filterable placeholder="转入账户" @change="account_in_oneChange"
                                              clearable>
                                              <el-option v-for="(value, key) in account_one" :key="key" :label="value.name"
                                                :value="value.bank_account_id">
                                              </el-option>
                                            </el-select>
                                          </el-tooltip>
                                    </div>
                        </div>
              </div>
                  <div style="height:205px;">
                        <span style="display:flex;margin-left:10px">备注</span>
                        <el-tooltip class="item" effect="dark" content="备注" placement="bottom">
                          <textarea   placeholder="备注"  v-model="remark"  style="width:790px;height:140px;display:flex;margin-left:10px;margin-top:35px;border-radius:5px;border:1px solid #d1d1d1"></textarea>
                        </el-tooltip>
                  </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import GlobalHeader from '@/components/GlobalHeader.vue'
import { ERPTransferApi, ERPSearchApi , ERPTransferinfoApi , ERPTransfersaveApi  , ERPTransferdelApi } from "@/api/bank/Account_details.js"
const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    GlobalHeader
  },
  data() {
    return {
      activeIndex: "8-2",
      tableData: [],
      input1: null,
      pickerOptions: {
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "本周",
            onClick(picker) {
              const current = new Date();
              let nowDayOfWeek = current.getDay();
              if (nowDayOfWeek === 0) nowDayOfWeek = 7;
              const dayNum = 1 * 24 * 60 * 60 * 1000;
              const firstDate = new Date(current.valueOf() - (nowDayOfWeek - 1) * dayNum);
              const lastDate = new Date(new Date(firstDate).valueOf() + 6 * dayNum);
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "当月",
            onClick(picker) {
              const date = new Date();
              const year = date.getFullYear();
              const month = date.getMonth();
              let thisMonthStartDate = new Date(year, month, 1);
              let thisMonthEndDate = new Date(year, month + 1, 0);
              picker.$emit("pick", [thisMonthStartDate, thisMonthEndDate]);
            },
          },
          {
            text: "当年",
            onClick(picker) {
              var tYear = new Date().getFullYear();
              var startTime = new Date(tYear, 0, 1); //当前年第一天
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
          {
            text: "昨天",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 1);
              picker.$emit("pick", [start, start]);
            },
          },
          {
            text: "上周",
            onClick(picker) {
              const current = new Date(new Date().getTime() - 60 * 60 * 24 * 7 * 1000);
              let nowDayOfWeek = current.getDay();
              let diffToMonday =
                current.getDate() - nowDayOfWeek + (nowDayOfWeek === 0 ? -6 : 1);
              const firstDate = new Date(current.setDate(diffToMonday));
              const lastDate = new Date(current.setDate(diffToMonday + 6));
              picker.$emit("pick", [firstDate, lastDate]);
            },
          },
          {
            text: "上月",
            onClick(picker) {
              var now = new Date();
              var fd = new Date(now.getFullYear(), now.getMonth() - 1, 1);
              var ed = new Date(now.getFullYear(), now.getMonth(), 0);
              picker.$emit("pick", [fd, ed]);
            },
          },
          {
            text: "去年",
            onClick(picker) {
              var tYear = new Date().getFullYear() - 1;
              var startTime = new Date(tYear, 0, 1);
              var endTime = new Date(tYear, 11, 31); //当前年最后一天
              picker.$emit("pick", [startTime, endTime]);
            },
          },
        ],
      },
      order: null,
      orField: null,
      value0: '',
      value1: "",
      isValue3Empty_1: true,

      account_out_name: null,
      account_in_name: null,
      currency_out_name: null,
      currency_in_name: null,
      account_one: null,
      currency_one: null,


      account_out_name_one: null,
      account_in_name_one: null,
      currency_out_name_one: null,
      currency_in_name_one: null,
      amount_out: null,
      amount_in: null,
      remark:null,
      total: null,
      paginationInput: 95,
      currentPage1: 1,
      id: null,
      exchange_out: null,
      totalRow: null,
      dialogVisible: false,
      selectedId: null,
      account_in_id:null,

        dialogTop: null, // 初始值为1vh
        loading:false,
    };
  },
  created() {
    this.loading = true;
    ERPTransferApi({}).then((res => {
      this.tableData = res.data;
      this.total = res.total,
        this.currentPage1 = res.page - 0;
      this.totalRow = res.totalRow;
      this.loading=false
    }))

    ERPSearchApi().then((res) => {
      this.account_one = res.data.account
      this.currency_one = res.data.currency
    })
  },
  mounted() {
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
    // 在mounted钩子中监听窗口尺寸变化，根据不同尺寸修改dialogTop的值
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    // 在组件销毁前移除窗口尺寸变化的监听
    window.removeEventListener('resize', this.handleResize)
  },
  methods: {
    handleResize() {
      // 根据不同的屏幕尺寸设置不同的top值
      if (window.innerWidth <= 1920) {
        this.dialogTop = '1vh'
      } else if (window.innerWidth <= 2560) {
        this.dialogTop = '10vh'
      } else if (window.innerWidth <= 3440) {
        this.dialogTop = '15vh'
      } else if (window.innerWidth <= 3840) {
        this.dialogTop = '20vh'
      }
    },
    limitEvt() {
      this.getList();
    },

    showTab(tab) {
      this.activeTab = tab;
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },



    account_outChange(value) {
        this.account_out_name = value;
        this.getList()
    },
    account_inChange(value) {
      this.account_in_name = value;
      this.getList()
    },
    currency_inChange(value) {
      this.currency_in_name = value;
      this.getList()
    },
    currency_outChange(value) {
      this.currency_out_name = value;
      this.getList()
    },


    account_out_oneChange(value) {
      this.account_out_name_one = value;
    },
    account_in_oneChange(value) {
      this.account_in_id = value;

    },
    currency_in_oneChange(value) {
      this.currency_in_name_one = value;
    },
    currency_out_oneChange(value) {
      this.currency_out_name_one = value;
    },

    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
        this.orField = row.prop;
      } else if (row.order == "descending") {
        this.order = "desc";
        this.orField = row.prop;
      } else if (row.order == null) {
        this.order = "";
        this.orField = '';
      }
      this.getList();
    },

    huaguo(row, column, cell, event) {
      this.selectedId = row.transfer_id
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.transfer_id
    },
    validateInput() {
       // 使用正则表达式匹配整数和浮点数
      const regex = /^[+-]?\d*\.?\d*$/;
      if (!regex.test(this.amount_in)) {
        // 如果输入不符合要求，则清空输入框
        this.amount_in = '';
      }
      if (!regex.test(this.amount_out)) {
        // 如果输入不符合要求，则清空输入框
        this.amount_out = '';
      }
    },
    saveEvt() {
        this.selectedId =this.selectedId
          if (this.selectedId) {
             this.transfer_time = this.value1 / 1000
        let data = {
          orField: this.orField,
          orWhere: this.order,
           id:this.selectedId ,

          account_out_id: this.account_out_name_one,
          account_in_id: this.account_in_id,

          currency_out_id: this.currency_out_name_one,
          currency_in_id: this.currency_in_name_one,
          transfer_time: this.transfer_time,
          amount_in: this.amount_in,
          amount_out: this.amount_out,
          remark: this.remark
        };
        ERPTransfersaveApi(data).then((res) => {
          this.tableData = res.data;
          this.total = res.total;
          this.totalRow = res.totalRow;
          this.currentPage1 = res.page - 0;
           if (res.code == 1000) {
            // 保存成功
             this.dialogVisible = false
            // 显示保存成功的提示信息
            this.$message.success('保存成功');
              this.getList()
          } else {
              this.dialogVisible = true
            // 保存失败
            this.$message.error('保存失败：' + res.msg);
          }
        });
      }else if( !this.selectedId){
        this.transfer_time = this.value1 / 1000
        let data = {
          orField: this.orField,
          orWhere: this.order,
          account_out_id: this.account_out_name_one,
          account_in_id: this.account_in_id,
          currency_out_id: this.currency_out_name_one,
          currency_in_id: this.currency_in_name_one,
          transfer_time: this.transfer_time,
          amount_in: this.amount_in,
          amount_out: this.amount_out,
          remark:this.remark
        };
        ERPTransfersaveApi(data).then((res) => {
            if (res.code == 1000) {
            // 保存成功
            this.dialogVisible = false
            // 显示保存成功的提示信息
            this.$message.success('保存成功');
              this.getList()
          } else {
            // 保存失败
            this.dialogVisible = true
            this.$message.error('保存失败：' + res.msg);
          }
        });
      }

    },

    openChildDialog(type) {
      if (type == 1) {
        this.selectedId = '';
        this.amount_in = ''
        this.amount_out = ''
        this.account_in_name_one =''
        this.account_out_name_one = ''
        this.currency_in_name_one = ''
        this.currency_out_name_one = ''
        this.exchange = ''
        this.remark = ''
        this.id = ''
        this.value1 = ''
        this.exchange_out = ''
        this.account_in_id = ''
        this.dialogVisible = true
      } else if (type == 2) {
        ERPTransferinfoApi({
          id: this.selectedId
        }).then((res) => {
          if (res.code == 1000) {
            this.amount_in = res.data.amount_in;
            this.amount_out = res.data.amount_out;
            this.account_in_name_one = res.data.account_in_id;
            this.account_out_name_one = res.data.account_out_id;
            this.currency_in_name_one = res.data.currency_in_id;
            this.currency_out_name_one = res.data.currency_out_id;
            this.exchange = res.data.exchange;
            this.remark = res.data.remark;
            this.id = res.data.id;
            this.value1 = res.data.transfer_time * 1000
            this.exchange_out = res.data.exchange;
            this.dialogVisible = true
          }
        });
      }
    },

    //获取页面数据
    getList() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      // //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      this.loading = true;
      let data = {
        orField: this.orField,
        orWhere: this.order,
        account_out_name: this.account_out_name,
        account_in_name: this.account_in_name,
        currency_out_name: this.currency_out_name,
        currency_in_name: this.currency_in_name,
        page: this.currentPage1,
        limit: this.paginationInput,

        transfer_time_start: income_time_start ? income_time_start : '',
        transfer_time_end: income_time_end ? income_time_end : '',
      };
      ERPTransferApi(data).then((res) => {
        this.tableData = res.data;
        this.total = res.total;
        this.totalRow = res.totalRow;
        this.currentPage1 = res.page - 0;
        this.loading=false;
      });
    },

    excelEvt(){
       //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      // //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let data = {
        orField: this.orField,
        orWhere: this.order,
        account_out_name: this.account_out_name,
        account_in_name: this.account_in_name,
        currency_out_name: this.currency_out_name,
        currency_in_name: this.currency_in_name,
        page: this.currentPage1,
        limit: this.paginationInput,

        transfer_time_start: income_time_start ? income_time_start : '',
        transfer_time_end: income_time_end ? income_time_end : '',
        excel:1,
      };
      let genExcel = false;
      if (genExcel == false) {
        ERPTransferApi(data).then((res) => {
          this.loading = false
          // window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }
    },


    //清除数据
    cleanUpEvt() {
      this.loading = true
      this.value0 = '';
      this.account_out_name = '';
      this.account_in_name = '';
      this.currency_out_name = '';
      this.currency_in_name = '';

      this.$refs.sortTable.clearSort();

      ERPTransferApi().then((res) => {
        this.tableData = res.data;
        this.total  =res.total;
        this.loading=false
      });
    },

    open() {
      this.$confirm('是否永久删除', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ERPTransferdelApi({
          id:this.selectedId,
        }).then(res=>{
          if (res.code == 1000) {
             this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.dialogVisible = false
              this.getList()
          }else{
            alert(res.msg)
          }
        })
      })
    }
  },
  watch: {
    'value0': function (newVal, oldVal) {
      this.isValue3Empty_1 = !newVal;
    },
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../../style/transfer.less");



/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

.el-main {
  left: 175px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

/deep/.el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}


.edit {
  // width: 1000px;
  height: 40px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    width: 137px;
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    width: 137px;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}


/deep/.el-table th.el-table__cell {
  background: #dce6ee;
}

.pagination_box {
  min-width: 500px;
  display: flex;
  // align-items: center;
  justify-content: flex-end;
  position: absolute;
  right: 1px;
  z-index: 123;
  cursor: pointer;
}

/deep/.el-tabs--border-card {
  border: none;
}

/deep/.el-tabs--border-card>.el-tabs__content {
  padding: 0 !important;
}

/deep/.el-table__body-wrapper {
  overflow-y: auto;
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 145px;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: calc(100% - 178px);
}

.mainx {
  margin-top: 50px;
}

/deep/.el-table th.el-table__cell {
  background: #f5f7fa;
}

/deep/.el-tabs__header {
  width: 100%;
}

/deep/.el-table__footer-wrapper .gutter {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}


/* 添加一个新的类来将总计行移动到最上方 */
.move-top .el-table__summary-cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 根据需要调整背景颜色、字体样式等 */
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-tabs__item {
  border-radius: 3px 3px 0px 0px;
  background: #d9d9d9;
  margin-left: 4px;
  color: #979797;
  font-size: 12px;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs__item {
  padding: 0;
  width: 105px;
  height: 32px;
  line-height: 32px;
}

/deep/.el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #000;
  border-bottom: none;
}

/deep/.el-table__footer-wrapper tbody td.el-table__cell {
  background: #fff;
  border: none;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #fff !important;
}

//修改tabs的下划线 以及颜色
/deep/.el-tabs__nav-wrap::after {
  height: 0;
  border: 1px solid #d9d9d9;
}

/deep/.el-tabs__nav {
  transform: translateY(1px) !important;
}

/deep/.el-table th.el-table__cell>.cell {
  color: #333333;
  font-size: 12px;
  height: 23px;

}

/deep/.el-table td.el-table__cell div {
  font-size: 12px;
}

/deep/::placeholder {
  color: #d3d3d3;
  /* 这里替换为你想要的颜色值 */
  margin-left: 5px !important;
}

/deep/.el-input--suffix {
  width: 137px !important;
}



.maxs {
  background: #f00 !important;
}

/deep/.el-dialog__body {
  padding: 0 !important;
}

/deep/.el-collapse-item {
  width: 490px !important;
}


/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

//日期选择背景色改变
.your-css-class_box {
  background-color: #bcd9f8d4 !important;
}

//调整下拉选择input
.el-cascader {
  line-height: 25px;
  margin-left: 6px
}

.el-cascader /deep/.el-input__inner {
  height: 27px !important;
  min-width: 137px !important;
}


//溢出隐藏
.white_over {
  white-space: nowrap;
  overflow: hidden;
}



/deep/.el-form-item__label {
  font-size: 12px;
  padding: 0px;
}

/deep/.el-dialog__header {
  background: #D9D9D9;
}

/deep/.el-dialog__body {
  background: #D9D9D9;
}

.whole {
  width: 100%;
  height:550px;
  display: flex;

  /deep/.el-input {
    width: 280px;
  }
}

.banner {
  width: 78%;
  margin-left: 380px;
  height: 835px;
  // overflow: auto;
  padding-right: 7px;
}


.Completion_status {
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  border-radius: 5px;
  word-wrap: break-word;
  // display: flex;
  // flex-direction: column;

  /deep/.el-input__inner {
    width: 280px !important;
    border-radius: 5px;
    border: 0.5px solid #D9D9D9;
    height: 40px;
    margin-top: 5px;
  }

  /deep/.el-input--suffix {
    width: 280px !important;
  }
}

/deep/.el-form-item__label {
  padding: 0px;
  font-size: 12px;
  color: #333;
}



// 删除和保存的样式
.cloneEvt {
  display: flex;
  height: 24px;

  span:nth-child(1) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383EA;
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
  }

  span:nth-child(2) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}

.text_box_one {
  width: 282px;
  height: 150px;
  border-radius: 5px;
  border: 0.5px solid #D9D9D9;
}

.text_one {
  /deep/.el-form-item__content {
    margin-bottom: -10px;
  }
}


.content {
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  height: 801px;

  p:nth-child(1) {
    text-align: right;
    margin-right: 150px;
  }

  p:nth-child(2) {
    text-align: right;
    margin-right: 135px;
  }

  /deep/ .el-table__fixed-body-wrapper {
    overflow: hidden !important;
  }
}

.span {
  position: absolute;
  left: 1px;
  top: 40px;
  height: 35px;
  width: 80px;
  background: #fff;
  z-index: 120;
  font-size: 14px;
  line-height: 35px;
  text-align: left;
  padding-left: 13px;
}


/deep/.project_one{
  background: #f6fff9 !important;
}


/deep/.project_two{
  background: #edf9fd !important;
}


/deep/.el-table__footer tbody tr .project_one{
  background: #fff !important;
}
/deep/.el-table__footer tbody tr .project_two{
  background: #fff !important;
}

</style>
<style>
/* 日期选择背景色改变 */

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

/* 日期选择 第四个位置间距拉开 */
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 30px;
}


.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}

/* //项目管理列的颜色 */

</style>



// WEBPACK FOOTER //
// src/src/Bank_management/Transfer_details/index.vue